import FlatsList from './FlatsList';

export default FlatsList;



// WEBPACK FOOTER //
// ./src/components/FlatsList/index.js